import React, {Suspense} from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router';
import App from '../../pages/admin/apps/App';
import CmpAppConfiguration from "../../pages/admin/apps/CmpAppConfiguration";
import CmpAppGroupConfiguration from "../../pages/admin/apps/CmpAppGroupConfiguration";
import CmpAppAnalytics from "../../pages/admin/apps/CmpAppAnalytics";
import Admin from '../../pages/admin/apps/Admin';
import AppRemoteConfiguration from '../../pages/admin/apps/AppRemoteConfiguration';

function Apps(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route path={`${path}/:appId/sdk/remote_configuration`} component={AppRemoteConfiguration}/>
        <Route path={`${path}/:appId/cmp/configuration`} component={CmpAppConfiguration}/>
        <Route path={`${path}/:appId/cmp/analytics`} component={CmpAppAnalytics}/>
        <Route path={`${path}/groups/:appGroupId/cmp/configuration`} component={CmpAppGroupConfiguration}/>
        <Route path={`${path}/:appId/admin`} component={Admin}/>
        <Route path={`${path}/:appId`} component={App}/>
      </Switch>
    </Suspense>
  )
}

export default Apps
